<template>
  <div id="modal" class="modal plan_search_modal" v-show="modalShown"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main modal-container" id="order_search_modal">
      <div class="modal-header" id="modal-moving">絞り込み検索</div>
      <div class="search_content">
        <div class="container search_li" v-if="isSalesList">
          <div class="search_th">状況</div>
          <div class="search_td container flex-wrap">
            <div v-for="(status, index) in statusList" :key="'st-' + index">
              <input type="checkbox" :id="'pro_' + index" @click="setStatus($event, status.code)"
                v-model="planStatus" :value="status.code"/>
              <label :for="'pro_' + index">{{ status.label }}</label>
            </div>
          </div>
        </div>
        <div class="container search_li" v-if="isSalesList">
          <div class="search_th">見積日</div>
          <div class="search_td">
            <input type="date" v-model="searchForm.estimateDateStart">
            <div class="separator">～</div>
            <input type="date" v-model="searchForm.estimateDateEnd">
          </div>
        </div>
        <div class="container search_li" v-if="isManufactureList || isOutputSheetList">
          <div class="search_th">生産日</div>
          <div class="search_td">
            <input type="date" v-model="searchForm.manufactureDateStart">
            <div class="separator">～</div>
            <input type="date" v-model="searchForm.manufactureDateEnd">
          </div>
        </div>
        <div class="container search_li" v-if="isConfirmedOrderList || isManufactureList">
          <div class="search_th">納品日</div>
          <div class="search_td">
            <input type="date" v-model="searchForm.deliveryDateStart">
            <div class="separator">～</div>
            <input type="date" v-model="searchForm.deliveryDateEnd">
          </div>
        </div>
        <div class="container search_li" v-if="isManufactureList">
          <div class="search_th">生産完了日</div>
          <div class="search_td">
            <input type="date" v-model="searchForm.completeDateStart">
            <div class="separator">～</div>
            <input type="date" v-model="searchForm.completeDateEnd">
          </div>
        </div>
        <div class="container search_li" v-if="isManufactureList || isOutputSheetList">
          <div class="search_th">計画ID</div>
            <input type="text" class="search_td" v-model="searchForm.planRotCode" maxlength="15">
        </div>
        <div class="container search_li" v-if="isManufactureList">
          <div class="search_th">プランID</div>
            <input type="text" class="search_td" v-model="searchForm.umPlanid" maxlength="15">
        </div>
        <div class="container search_li" v-if="isSalesList || isManufactureList">
          <div class="search_th">プラン名</div>
            <input type="text" class="search_td" v-model="searchForm.fileName" maxlength="50">
        </div>
      </div>
      <div class="modal-footer">
        <button class="main_btn pos_left" @click="clear()">クリア</button>
        <button class="main_btn pos_right" @click="close()">閉じる</button>
        <button class="main_btn search_btn" @click="search()">検索</button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'PlanSearchModal',
  props: {
    isSalesList: Boolean,
    isConfirmedOrderList: Boolean,
    isManufactureList: Boolean,
    isOutputSheetList: Boolean
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      statusList: {
        ORDER: {code: 7, label: '受注'},
        SALES_A: {code: 1, label: 'A'},
        SALES_B: {code: 2, label: 'B'},
        SALES_C: {code: 3, label: 'C'},
        ORDER_CANCEL: {code: 60, label: '失注'},
        ORDER_EXCLUDED: {code: 70, label: '営業対象外'},
        UNDEFINED: {code: 0, label: '未設定'}
      },
      searchForm: {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        fileName: ''
      },
      planStatus: []
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    close: function () {
      this.modalShown = false
    },
    search: function () {
      this.modalShown = false
      this.searchForm.planStatus = this.planStatus
      this.$emit('onClickSearch', this.searchForm)
    },
    clear: function () {
      this.searchForm = {
        planStatus: [],
        estimateDateStart: '',
        estimateDateEnd: '',
        manufactureDateStart: '',
        manufactureDateEnd: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        completeDateStart: '',
        completeDateEnd: '',
        planRotCode: '',
        umPlanid: '',
        fileName: '',
        pageNo: '',
        dataCount: ''
      }
      this.planStatus = []
    },
    setStatus: function (event, code) {
      if (event.target.checked === true) {
        this.planStatus.push(code)
      } else {
        this.planStatus = this.planStatus.filter(s => s !== code)
      }
    },
    formatDate: function (date) {
      if (!date) return ''
      let strDate = moment(date).format('YYYY-MM-DD')
      return strDate
    }
  }
}
</script>

<style src="../../../css/order/order_search.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.modal-container {
  max-width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/PlanSearchModal.vue